export const AuthLoading = () => (
  <p className="text-center text-sm text-muted-foreground" role="status">
    Loading…
  </p>
)
